<template>
  <PopupModal :open="open" has-close-button @close="close">
    <template #body>
      <div>
        <div class="text-large mb-8">
          {{ t("comp.challenge.started.tab.team.kick.dialog.title") }}
        </div>
        <div>
          {{
            t("comp.challenge.started.tab.team.kick.dialog.text", {
              memberName: memberName,
              teamName: teamName,
            })
          }}
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex flex-row w-full justify-center gap-4">
        <div class="text-center">
          <ButtonElement
            :label="t('comp.challenge.started.tab.team.kick.dialog.cancel')"
            :disabled-visible="true"
            @click="close"
          />
        </div>
        <div class="text-center">
          <ButtonElement
            :label="t('comp.challenge.started.tab.team.kick.dialog.confirm')"
            @click="kick"
          />
        </div>
      </div>
    </template>
  </PopupModal>
</template>
<script setup lang="ts">
import PopupModal from "../layout/PopupModal.vue";
import ButtonElement from "../form/ButtonElement.vue";
import { useI18n } from "vue-i18n";
import { kickTeamMember } from "../../../api/v2/competitive-challenge.ts";
import { useNotificationStore } from "../../../store/v2/notification.js";

const { t } = useI18n();

const notificationStore = useNotificationStore();
const emit = defineEmits(["close", "memberKicked"]);

const props = defineProps({
  open: {
    type: Boolean,
    required: true,
  },
  teamId: {
    type: Number,
    required: true,
  },
  memberId: {
    type: Number,
    required: true,
  },
  memberName: {
    type: String,
    required: true,
  },
  teamName: {
    type: String,
    required: true,
  },
});

async function kick() {
  try {
    const res = await kickTeamMember(props.teamId, props.memberId);
    if (res) {
      emit("memberKicked");
      emit("close");
    }
  } catch (error) {
    notificationStore.addNotification(
      Date.now(),
      null,
      t("comp.challenge.started.tab.team.kick.dialog.title"),
      t("comp.challenge.started.tab.team.kick.dialog.error"),
      true
    );
    emit("close");
  }
}

function close() {
  emit("close");
}
</script>
